import { YES_NO_OPTIONS } from '../contants/common';
import { trimObjectValues, valueToNumber, valueToString } from './format';

export const convertTmsSettingsApiToLocal = (data) => {
  data = trimObjectValues(data);
  return {
    companySettings: {
      brokerageCustomer: data?.brokerageCustomer,
      statusInTMS: data?.statusInTMS,
    },
    shipmentSettings: {
      nextID: data?.nextID,
      enableMasterOrders: data?.enableMasterOrders,
      pricingType: data?.pricingType,
      isvisiablePaidBy: data?.isvisiablePaidBy,
      shipmentApprovalRequired: data?.shipmentApprovalRequired,
      isCategoryToValidate: data?.isCategoryToValidate,
      isWeightCalculation: data?.isWeightCalculation,
      routingGuideMatch: data?.routingGuideMatch,
      defaultBranchKey: valueToNumber(data?.defaultBranchKey),
      defaultIncoTerm: data?.defaultIncoTerm,
      defaultSpotBidEndStatus: data?.defaultSpotBidEndStatus,
      displayPO_SOOnShipmentLevel: data?.displayPO_SOOnShipmentLevel,
      defaultProductCode: data?.defaultProductCode,
      defaultProdDesc: data?.defaultProdDesc,
      isShowRatingDetails: data?.isShowRatingDetails,
      defaultHazmat: data?.defaultHazmat,
      defaultRatingPreferencevalue: data?.defaultRatingPreferencevalue,
      defaultFreightClass: data?.defaultFreightClass,
      defaultLen: data?.defaultLen,
      defaultWidth: data?.defaultWidth,
      defaultHeight: data?.defaultHeight,
      defaultBusinessJustification: data?.defaultBusinessJustification,
      isDefaultRatingPreference: data?.isDefaultRatingPreference,
      defaultShipmentTerms: data?.defaultShipmentTerms,
      defaultShipmentType: data?.defaultShipmentType,
      shipmentApprovalCount: data?.shipmentApprovalCount,
      isRequiredApprovalNumber: data?.isRequiredApprovalNumber,
      adminEmail: data?.adminEmail,
      shipmentSupportMail: data?.shipmentSupportMail,
      emailFrom: data?.emailFrom,
      shipmentEmailAttachment: data?.shipmentEmailAttachment,
      qtyTolerancePercentage: data?.qtyTolerancePercentage,
      autoRate: data?.autoRate,
      recalculateFreightClass: data?.recalculateFreightClass > 0 ? 'Y' : 'N',
      autoTender: data?.autoTender,
      autoTenderAmount: data?.autoTenderAmount,
      autoTenderCargoType: data?.autoTenderCargoType === 'N' ? null : data?.autoTenderCargoType,
      isCategoryVisible: data?.isCategoryVisible,
      isBillToVisible: data?.isBillToVisible,
      isVendorVisible: data?.isVendorVisible,
    },
    auctionSettings: {
      defaultEquipmentType: data?.defaultEquipmentType,
      defaultCargoType: data?.defaultCargoType,
      disableExpiredBids: data?.disableExpiredBids,
      bidExpiryNoOfDays: data?.bidExpiryNoOfDays,
      isReverseAuction: data?.isReverseAuction,
      maxBidHours: data?.maxBidHours,
    },
    povSettings: {
      allowIncoCode: data?.allowIncoCode || '',
      poValidationFlag: data?.poValidationFlag,
      shipmentIdStartingInteger: data?.shipmentIdStartingInteger,
      shipmentIdAlphaPrefix: data?.shipmentIdAlphaPrefix,
      numberOfRoutingCarrierReturned: data?.numberOfRoutingCarrierReturned,
      povDestinationMethod: data?.povDestinationMethod,
      routingMethod: data?.routingMethod,
      allowDraftShipments: data?.allowDraftShipments,
      defaultPackageUom: data?.defaultPackageUom,
      defaultUom: data?.defaultUom,
      defaultFobCode: data?.defaultFobCode,
      defaultClass: data?.defaultClass,
      minimumDays: data?.minimumDays,
      maximumDays: data?.maximumDays,
      minimumDaysErrorMsg: data?.minimumDaysErrorMsg,
      maximumDaysErrorMsg: data?.maximumDaysErrorMsg,
      shipmentTermsAllowed: data?.shipmentTermsAllowed,
      isCatchDate: data?.isCatchDate,
      isPoItemLocation: data?.isPoItemLocation,
    },
    supplierModuleSettings: {
      earlyShipmentRestrictionDetails: data?.earlyShipmentRestrictionDetails || [],
      isAllowEarlyShipmentRestriction: data?.isAllowEarlyShipmentRestriction || YES_NO_OPTIONS[1].value,
    },
  };
};

export const convertTmsSettingsLocalToAPI = (data) => {
  if (data) {
    data = {
      ...data,
      adminEmail: valueToString(data.adminEmail),
      autoRate: valueToString(data.autoRate),
      autoTender: valueToString(data.autoTender),
      autoTenderAmount: valueToNumber(data.autoTenderAmount),
      autoTenderCargoType: valueToString(data.autoTenderCargoType),
      bidExpiryNoOfDays: valueToNumber(data.bidExpiryNoOfDays),
      brokerageCustomer: valueToString(data.brokerageCustomer),
      defaultBranchKey: valueToNumber(data.defaultBranchKey) !== '' ? valueToNumber(data.defaultBranchKey) : '',
      defaultBusinessJustification: valueToString(data.defaultBusinessJustification),
      defaultCargoType: valueToString(data.defaultCargoType),
      defaultClass: valueToString(data.defaultClass),
      defaultEquipmentType: valueToNumber(data.defaultEquipmentType),
      defaultFobCode: valueToString(data.defaultFobCode),
      defaultFreightClass: valueToString(data.defaultFreightClass),
      defaultHazmat: valueToString(data.defaultHazmat),
      defaultHeight: valueToString(data.defaultHeight),
      defaultIncoTerm: valueToString(data.defaultIncoTerm),
      defaultLen: valueToString(data.defaultLen),
      defaultPackageUom: valueToString(data.defaultPackageUom),
      defaultProdDesc: valueToString(data.defaultProdDesc),
      defaultProductCode: valueToString(data.defaultProductCode),
      defaultRatingPreferencevalue: valueToString(data.defaultRatingPreferencevalue),
      defaultShipmentTerms: valueToString(data.defaultShipmentTerms),
      defaultShipmentType: valueToString(data.defaultShipmentType),
      defaultSpotBidEndStatus:
        !data.defaultSpotBidEndStatus || data.defaultSpotBidEndStatus === ''
          ? ' '
          : valueToString(data.defaultSpotBidEndStatus),
      defaultUom: valueToString(data.defaultUom),
      defaultWidth: valueToString(data.defaultWidth),
      emailFrom: valueToString(data.emailFrom),
      enableMasterOrders: valueToString(data.enableMasterOrders),
      isCategoryToValidate: valueToString(data.isCategoryToValidate),
      isDefaultRatingPreference: valueToString(data.isDefaultRatingPreference),
      isRequiredApprovalNumber: valueToString(data.isRequiredApprovalNumber),
      isReverseAuction: valueToString(data.isReverseAuction),
      isShowRatingDetails: valueToString(data.isShowRatingDetails),
      isWeightCalculation: valueToString(data.isWeightCalculation),
      isvisiablePaidBy: valueToString(data.isvisiablePaidBy),
      maxBidHours: valueToNumber(data.maxBidHours),
      maximumDays: valueToNumber(data.maximumDays),
      maximumDaysErrorMsg: valueToString(data.maximumDaysErrorMsg),
      minimumDays: valueToNumber(data.minimumDays),
      minimumDaysErrorMsg: valueToString(data.minimumDaysErrorMsg),
      nextID: valueToNumber(data.nextID) !== '' ? valueToNumber(data.nextID) : ' ',
      numberOfRoutingCarrierReturned: valueToNumber(data.numberOfRoutingCarrierReturned),
      poValidationFlag: valueToString(data.poValidationFlag),
      povDestinationMethod: data.poValidationFlag === 'Y' ? valueToString(data.povDestinationMethod) : ' ',
      pricingType: valueToString(data.pricingType) !== '' ? valueToString(data.pricingType) : ' ',
      qtyTolerancePercentage: valueToNumber(data.qtyTolerancePercentage),
      routingMethod: valueToString(data.routingMethod),
      shipmentApprovalCount: valueToNumber(data.shipmentApprovalCount),
      shipmentApprovalRequired: valueToString(data.shipmentApprovalRequired),
      shipmentEmailAttachment: valueToString(data.shipmentEmailAttachment),
      shipmentIdAlphaPrefix: valueToString(data.shipmentIdAlphaPrefix),
      shipmentIdStartingInteger: valueToNumber(data.shipmentIdStartingInteger),
      shipmentSupportMail: valueToString(data.shipmentSupportMail),
      shipmentTermsAllowed: valueToString(data.shipmentTermsAllowed),
      statusInTMS: valueToString(data.statusInTMS),
      disableExpiredBids: valueToString(data.disableExpiredBids),
      displayPO_SOOnShipmentLevel: valueToString(data.displayPO_SOOnShipmentLevel),
      recalculateFreightClass: data.recalculateFreightClass === 'Y' ? 1 : 0,
      allowDraftShipments: valueToString(data.allowDraftShipments),
      isCategoryVisible: valueToString(data.isCategoryVisible),
      isBillToVisible: valueToString(data.isBillToVisible),
      isVendorVisible: valueToString(data.isVendorVisible),
      earlyShipmentRestrictionDetails: formatCargoTypeRestrictions(data.earlyShipmentRestrictionDetails),
    };
  }
  return data;
};

export const formatCargoTypeRestrictions = (restrictions = []) => {
  const restrictionsPrepared = restrictions.map(({ isNew, id, ...item }) => ({
    cargoType: item.cargoType,
    maximumDays: parseInt(item.maximumDays),
    maximumDaysError: item.maximumDaysError,
    customerKey: item.customerKey,
    ...(!isNew ? { id } : {}),
  }));

  return restrictionsPrepared;
};
